// @ts-nocheck
import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { BLOOD_TYPE } from '../../../../common/constants'
import Field from '../../../fields'
import { showLps } from '../../../../screens/Residents/screens/ResidentProfileScreen/_legacyReidentProfileScreen/components/ResidentProfilePrimary'
import dayjs from 'dayjs'

const ResidentOtherDetails = ({ fields, formId, style, features }) => {
  const isCanada = features.countryCode === 'CA'
  const isLps = showLps(features.countryCode)
  if (!fields) return null

  return (
    <div style={style}>
      {features.carePlans && !isCanada && (
        <>
          <Suspense fallback={<div>Loading...</div>}>
          <Field
            keys="dnacpr"
            label="DNACPR"
            formId={formId}
            options={[
              {
                value: false,
                label: <div>Attempt CPR</div>,
              },
              {
                value: true,
                label: (
                  <div>
                    <u>Do Not</u> Attempt CPR
                  </div>
                ),
              },
            ]}
            type="radios"
            values={fields}
            style={styles.dnaCprField}
          />
          </Suspense>
          <Suspense fallback={<div>Loading...</div>}>
          <Field
            dependsOn={{
              key: 'dnacpr',
              value: true,
            }}
            displayLabel={false}
            keys="dnacprDetails"
            label="DNACPR details"
            formId={formId}
            options={[
              { value: 'Indefinite decision' },
              { value: 'Under review' },
            ]}
            required
            type="radios"
            values={fields}
          />
          </Suspense>
          <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="dols"
              label={
                isLps
                  ? 'Liberty Protection Safeguard (LPS)'
                  : 'Deprivation of Liberty Safeguards (DoLS)'
              }
              formId={formId}
              options={[
                { value: true, label: 'Yes' },
                { value: false, label: 'No' },
              ]}
              type="radios"
              values={fields}
            />
            </Suspense>
          </div>
          {fields.dols && (
            <>
              <div style={styles.fieldContainer}>
              <Suspense fallback={<div>Loading...</div>}>
                <Field
                  dependsOn={{
                    key: 'dols',
                    value: true,
                  }}
                  keys="dolsStartDate"
                  label={isLps ? 'LPS Start Date' : 'DoLS Start Date'}
                  formId={formId}
                  options={{
                    date: true,
                    delimiter: '-',
                    datePattern: ['d', 'm', 'Y'],
                  }}
                  placeholders="DD-MM-YYYY"
                  type="formattedText"
                  validationTypes={['validDate']}
                  values={fields}
                />
                </Suspense>
              </div>
              <div style={styles.fieldContainer}>
              <Suspense fallback={<div>Loading...</div>}>
                <Field
                  dependsOn={{
                    key: 'dols',
                    value: true,
                  }}
                  keys="dolsEndDate"
                  label={isLps ? 'LPS End Date' : 'DoLS End Date'}
                  formId={formId}
                  options={{
                    date: true,
                    delimiter: '-',
                    datePattern: ['d', 'm', 'Y'],
                  }}
                  placeholders="DD-MM-YYYY"
                  type="formattedText"
                  validationTypes={['validDate']}
                  values={fields}
                />
                </Suspense>
              </div>
              <div style={styles.fieldContainer}>
              <Suspense fallback={<div>Loading...</div>}>
                <Field
                  dependsOn={{
                    key: 'dols',
                    value: true,
                  }}
                  keys="dolsApplicationDate"
                  label={
                    isLps ? 'LPS Application Date' : 'DoLS Application Date'
                  }
                  formId={formId}
                  options={{
                    date: true,
                    delimiter: '-',
                    datePattern: ['d', 'm', 'Y'],
                  }}
                  placeholders="DD-MM-YYYY"
                  type="formattedText"
                  validationTypes={['validDate']}
                  values={fields}
                />
                </Suspense>
              </div>
              <div style={styles.fieldContainer}>
              <Suspense fallback={<div>Loading...</div>}>
                <Field
                  dependsOn={{
                    key: 'dols',
                    value: true,
                  }}
                  keys="dolsReviewDate"
                  label={isLps ? 'LPS Review Date' : 'DoLS Review Date'}
                  formId={formId}
                  options={{
                    date: true,
                    delimiter: '-',
                    datePattern: ['d', 'm', 'Y'],
                  }}
                  placeholders="DD-MM-YYYY"
                  type="formattedText"
                  validationTypes={['validDate']}
                  values={fields}
                />
                </Suspense>
              </div>
            </>
          )}
        </>
      )}
      <div style={styles.fieldContainer}>
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          keys="hasAllergies"
          label="Allergies"
          formId={formId}
          options={[
            { value: 'Yes', label: 'Yes' },
            { value: 'None known', label: 'None known' },
          ]}
          type="radios"
          values={fields}
        />
        </Suspense>
      </div>
      <div style={styles.fieldContainer}>
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          dependsOn={{
            key: 'hasAllergies',
            value: 'Yes',
          }}
          keys="allergies"
          required
          label="Allergy Details"
          formId={formId}
          type="text"
          values={fields}
        />
        </Suspense>
      </div>
      {features.carePlans && (
        <>
          <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="bloodType"
              label="Blood Type"
              formId={formId}
              options={BLOOD_TYPE}
              type="select"
              values={fields}
            />
            </Suspense>
          </div>
          <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="medicalHistory"
              label="Medical History"
              formId={formId}
              type="textarea"
              values={fields}
            />
            </Suspense>
          </div>
          <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="admissionDate"
              label="Admission date"
              formId={formId}
              options={{
                date: true,
                delimiter: '-',
                datePattern: ['d', 'm', 'Y'],
              }}
              placeholder="DD-MM-YYYY"
              type="formattedText"
              validationTypes="validDate"
              values={fields}
            />
            </Suspense>
          </div>
          {!isCanada && (
            <div style={styles.fieldContainer}>
              <Suspense fallback={<div>Loading...</div>}>
              <Field
                keys="nationalInsurance"
                label="National Insurance number"
                formId={formId}
                options={{
                  blocks: [2, 2, 2, 2, 1],
                  delimiter: ' ',
                  uppercase: true,
                }}
                type="formattedText"
                validationTypes="nationalInsurance"
                values={fields}
              />
              </Suspense>
            </div>
          )}
          <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="nhsNumber"
              label={isCanada ? 'Health Care Number' : 'NHS number'}
              formId={formId}
              options={{
                blocks: [3, 3, 3, 3],
                delimiter: ' ',
                numericOnly: true,
              }}
              type="formattedText"
              validationTypes={isCanada ? 'canadaNhsNumber' : 'nhsNumber'}
              values={fields}
            />
            </Suspense>
          </div>
          <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="fundingSource"
              label="Funding source"
              formId={formId}
              options={[
                { value: 'Local Authority' },
                { value: 'Private' },
                { value: 'Local Authority + Private top-up' },
                { value: 'Other' },
              ]}
              type="radios"
              values={fields}
            />
            </Suspense>
          </div>
          <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="fundingSourceOther"
              label="Other funding source"
              formId={formId}
              type="text"
              values={fields}
              required
              dependsOn={{
                key: 'fundingSource',
                value: 'Other',
              }}
            />
            </Suspense>
          </div>
          <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="height"
              label="Height (cm)"
              formId={formId}
              options={{
                blocks: [3],
                numericOnly: true,
              }}
              type="formattedText"
              values={fields}
              validationTypes="height"
            />
            </Suspense>
          </div>
        </>
      )}
      {features.eMAR && (
        <>
          <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="preferredAdminRoute"
              label="Tablets in hand/pot/mouth"
              formId={formId}
              type="textarea"
              values={fields}
            />
            </Suspense>
          </div>
          <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="preferredDrink"
              label="Preferred drink"
              formId={formId}
              type="textarea"
              values={fields}
            />
            </Suspense>
          </div>
          <div style={styles.fieldContainer}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="prnMedsNote"
              label="PRN Meds"
              formId={formId}
              type="textarea"
              values={fields}
            />
            </Suspense>
          </div>
        </>
      )}
    </div>
  )
}

const styles = {
  fieldContainer: {
    paddingTop: 20,
  },
  title: {
    display: 'block',
    fontSize: 18,
    fontWeight: 'bold',
  },
}

export default ResidentOtherDetails
